export const MAXHP: string = 'maxHp'
export const MAXSP: string = 'maxSp'
export const ATK: string = 'atk'
export const PDEF: string = 'pdef'
export const SDEF: string = 'sdef'
export const STR: string = 'str'
export const AGI: string = 'agi'
export const INT: string = 'int'
export const DEX: string = 'dex'